export default "https://cdn-static.gokick.com/assets/6600ddf3ffcd3e3653ecf6807c0977bcbaa0931f/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";